import { Flex, theme } from 'modules/ui';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const CalculatorContainer = styled(Flex)`
  margin-top: -3rem;
`;

export const ContentWrapper = styled(Flex)`
  margin-top: 2.75rem;

  ${mediaQuery('md')} {
    gap: 1rem;
  }
`;

export const RowContainer = styled(Flex)`
  width: 100%;

  ${mediaQuery('md')} {
    flex-direction: row;
    gap: 8.938rem;
  }
`;

export const FooterLine = styled.div`
  height: 1px;
  background-color: ${theme.colors.primaryK3};

  margin-top: 3.75rem;
  margin-bottom: 2.5rem;

  ${mediaQuery('md')} {
    margin-top: 4rem;
    margin-bottom: 5.313rem;
  }
`;

export const EksDisclaimerContainer = styled.div`
  width: 100%;
  margin-top: 2rem;
  padding: 1.5rem;
  font-size: 0.875rem;
  line-height: 1.5;
  color: ${theme.colors.primaryK5};
  white-space: pre-line;
`;

export const LeasingDataContainer = styled(Flex)<{
  marginTop?: string;
}>`
  width: 100%;
  margin-top: 3.5rem;
  gap: 1rem;
  order: 2;

  ${mediaQuery('md')} {
    margin-top: ${(props) => (props.marginTop ? props.marginTop : '2rem')};
    gap: 1.5rem;
    order: unset;
  }
`;
